import { ca } from '@cian/analytics';

import {
  type AdfoxEventActionType,
  type FinalAdfoxAnalyticsPayload,
  type MiddleAdfoxAnalyticsPayload,
} from 'shared/types/analytics';
import { EAdfoxAnalyticsPayloadType } from 'shared/enums/adfoxAnalyticsPayloadType';

import { toISOStringWithTimeZone } from './toISOStringWithTimeZone';

type Product = {
  extra: Record<string, string | number | boolean>;
  id?: number;
  name: string;
  position?: number;
};

type Payload = MiddleAdfoxAnalyticsPayload | FinalAdfoxAnalyticsPayload;

type SendTeaserWebAdfoxEvent = {
  (action: AdfoxEventActionType): void;
  payload: Payload;
};

/** Отправка события по Adfox-баннеру в тизер */
export function sendTeaserWebAdfoxEventFactory(payload: Payload): SendTeaserWebAdfoxEvent {
  const nested: SendTeaserWebAdfoxEvent = action => {
    const { bannerSource, place, isSp, p1, p2, galleryPosition, position, traceId } = payload;

    const date = new Date();

    const product: Product = {
      extra: {
        action,
        bannerPlace: place,
        bannerSource,
        dateAt: toISOStringWithTimeZone(date),
        eventDate: date.getTime(),
        isSp: !!isSp,
        p1,
        p2,
        traceId,
      },
      name: `banner_${action}`,
    };

    if (galleryPosition != null) {
      product.extra.galleryPosition = galleryPosition;
    }
    if (position != null) {
      product.position = position;
    }

    switch (payload.type) {
      case EAdfoxAnalyticsPayloadType.WithAdfoxData:
        product.extra.bundleName = payload.bundleName;
        product.id = payload.id;
        product.extra.campaignId = payload.campaignId;

        Object.assign(product.extra, payload.jsonFields);

        break;

      case EAdfoxAnalyticsPayloadType.WithAdfoxErrorData:
        product.extra.errorType = payload.errorType;
        product.extra.errorMessage = payload.errorMessage;

        break;
    }

    ca('teaser', { product });
  };

  nested.payload = payload;

  return nested;
}
